import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { clearTopup } from 'redux/modules/topup/actions';
import Header from './subcomponents/Header';
import Body from './subcomponents/Body';

interface PaymentConfirmationDialogProps {
	isOpen: boolean;
	isError: boolean;
	hardReset: () => void;
	topUpValue: string | number;
	donationValue: number;
}

const PaymentConfirmationDialog = (props: PaymentConfirmationDialogProps) => {
	const { isOpen, isError, hardReset, topUpValue, donationValue } = props;
	const history = useHistory();
	const dispatch = useDispatch();

	const hideDialog = () => {
		history.push('/dashboard/payments/topup');
		dispatch(clearTopup());
		hardReset();
	};

	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			isError={isError}
			hideDialog={hideDialog}
			header={<Header isError={isError} topUpValue={topUpValue} donationValue={donationValue} />}
		>
			<Body isError={isError} />
		</CustomConfirmationDialog>
	);
};

export default PaymentConfirmationDialog;
